import { AmplitudeFeatureFlagNames } from '@/libs/feature-flags';
import { useAmplitudeExperiment } from '../use-experiments';

export const useBffFlag = () => {
    const { isEnrolled: bffFlagEnabled, isLoading } = useAmplitudeExperiment({
        experimentName: AmplitudeFeatureFlagNames.BACKEND_FOR_FRONTEND_ENABLED,
    });

    return { bffFlagEnabled, isLoading };
};
